import { render, staticRenderFns } from "./CartaoTap.vue?vue&type=template&id=611bb9f4&scoped=true"
import script from "./CartaoTap.vue?vue&type=script&lang=js"
export * from "./CartaoTap.vue?vue&type=script&lang=js"
import style0 from "./CartaoTap.vue?vue&type=style&index=0&id=611bb9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611bb9f4",
  null
  
)

export default component.exports